import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { FirebaseService } from './firebase.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';

import { take } from "rxjs/operators";
import { Storage } from '@ionic/storage';
import { Events } from './events.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn = false;
  user;

  constructor(
    private firebaseService: FirebaseService,
    public afs: AngularFirestore,
    public storage: Storage,
    public events: Events,
    public afAuth: AngularFireAuth
  ) { }

  setLoggedIn(_value) {
    this.isLoggedIn = _value;
  }

  isAdmin() {
    console.log("isAdmin user", this.user);
    if (this.isLoggedIn && this.user && this.user.status && this.user.status == 3)
      return true;
    return false;
  }

  getUser() {
    return this.user;
  }
  deleteUser() {
    this.afAuth.currentUser.then(user => {
      user?.delete()
      this.doLogout();
  });
  }

  async setUser(user_id) {
    return new Promise<any>((resolve, reject) => {
      console.log("setUser user", user_id);
      if (user_id != null) {
        let snapshotChangesRef = this.afs.collection('users').doc(user_id)
        snapshotChangesRef.valueChanges()
          .pipe(take(1))
          .subscribe(data => {
            console.log("setUser data", data);
            if (data) {
              data["uid"] = user_id;
              this.user = data;
              this.events.publish("user", this.user);
              resolve(data);
            }
          }, err => {
            this.user = null;
            resolve(null);
          })
      }
      else {
        this.user = null;
        resolve(null);
      }
    })
  }


  updateUser(uid, user) {
    return new Promise<any>((resolve, reject) => {
      console.log("updateUser", uid, user);
      this.afs.collection('users').doc(uid).set(user)
        .then(
          res => resolve(user),
          err => reject(err)
        )
    })
  }


  isAnonymous(): boolean {
    console.log("isAnonymous", this.user);
    return this.user && this.user.isAnonymous ? true : false;
  }

  isAuthenticated(): boolean {
    return this.isLoggedIn;
  }


  createUser(uid, user) {
    return new Promise<any>((resolve, reject) => {
      console.log("createUser", user);
      this.afs.collection('users').doc(uid).set(user)
        .then(
          res => resolve(user),
          err => reject(err)
        )
    })
  }



  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.createUserWithEmailAndPassword(value.email, value.password)
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }

  doRegisterEmail(email) {
    return new Promise<any>((resolve, reject) => {
      let root_url = this.getAppRootUrl();
      this.afAuth.sendSignInLinkToEmail(email,
        {
          url: root_url,
          handleCodeInApp: true,
          iOS: {
            bundleId: "com.reussys.appie"
          },
          android: {
            packageName: "com.reussys.appie"
          }
        })
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }
  async confirmSignIn(url) {
    try {

      console.log("confirmSignIn", url);
      if (this.afAuth.isSignInWithEmailLink(url)) {
        let email = await this.storage.get('emailForSignIn');

        // If missing email, prompt user for it
        if (!email) {
          return 'prompt';
        }
        const result = await this.afAuth.signInWithEmailLink(email, url);
        console.log("result", result);

      }
    } catch (err) {
      console.error('confirmSignIn err', err);
    }
  }

  private getAppRootUrl(): string {

    // Since the demo may be running locally or on GitHub; and, using the Hash or
    // Path location strategy; we need to calculate the the ingress using the the
    // name of the demo folder that we know we're in.
    // Find the index of this folder in the browser URL.
    var folderIndex = window.location.href.indexOf('register');

    // Return the URL prefix up-to and including the demo folder. This will be the
    // base off of which we append all internal app-URLs.
    return (window.location.href.slice(0, folderIndex)) + 'login';

  }

  doLogin(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.signInWithEmailAndPassword(value.email, value.password)
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }


  async getCredentials() {
    return await this.storage.get('emailForSignIn');
  }
  async setCredentials(value) {
    await this.storage.set('credentials', { email: value.email, password: value.password });
  }
  async deleteCredentials() {
    await this.storage.remove('emailForSignIn');
  }

  doLoginAnonymous() {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.signInAnonymously()
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }

  doNewPassword(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.sendPasswordResetEmail(value.email)
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }

  doLogout() {
    console.log("doLogout")
    return new Promise(async (resolve, reject) => {
      await this.deleteCredentials();
      this.afAuth.signOut()
        .then(() => {
          this.setLoggedIn(false);
          this.firebaseService.unsubscribeOnLogOut();
          resolve(null);
        }).catch((error) => {
          this.setLoggedIn(false);
          console.error(error);
          reject();
        });
    })
  }
}
